import React from "react";
import BranchCard from "./BranchCard";

interface BranchListProps {
  branches: any[];
  showDeletedBranches: boolean;
  onEdit: (branch: any) => void;
  onDelete: (id: string) => void;
}

const BranchList: React.FC<BranchListProps> = ({ branches, showDeletedBranches, onEdit, onDelete }) => {
  if (branches.length === 0) return <p>No data available</p>;

  return (
    <div className="branch-display">
      {branches.map((branch) => (
        <BranchCard
          key={branch._id.$oid}
          branch={branch}
          onEdit={onEdit}
          onDelete={onDelete}
          showDeletedBranches={showDeletedBranches}
        />
      ))}
    </div>
  );
};

export default BranchList;
